export var NOT_FOCUSED_STATE = {
  focus: false
};
export var FOCUSED_STATE = {
  focus: true
};